export default __webpack_public_path__ + "static/media/Essex_County_Council.6371021c.svg";